import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { useSelector } from '@grandvisionhq/state';
import { StepWrapper } from '../../../../../../Configurator/components/StepWrapper/StepWrapper.js';
import { getUsps } from '../../../../state/configurator/selectors.js';

var RxStepWrapper = (_param)=>{
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    const usps = useSelector(getUsps);
    return /*#__PURE__*/ React__default.createElement(StepWrapper, {
        "data-t": rest['data-t'],
        className: classnames('prescription-glasses-step', className),
        usps: usps
    }, children);
};

export { RxStepWrapper };
//# sourceMappingURL=RxStepWrapper.js.map
